// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import Sidebar from '../Sidebar/Sidebar';

// function PoojaBooking() {
//   const [poojaList, setPoojaList] = useState([]);
//   const [bookingData, setBookingData] = useState({
//     mobileNumber: '',
//     customerName: '',
//     gothram: '',
//     poojaDate: '',
//     poojaDetails: [],
//   });

//   const [count, setCount] = useState(0);

//   useEffect(() => {
//     // Fetch pooja names from the backend
//     axios.get('https://posapi.emedha.in/api/pooja')
//       .then(response => {
//         setPoojaList(response.data);
//       })
//       .catch(error => {
//         console.error("Error fetching pooja data", error);
//       });
//   }, []);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setBookingData({
//       ...bookingData,
//       [name]: value,
//     });
//   };

//   const handlePoojaChange = (index, e) => {
//     const { name, value } = e.target;
//     const updatedPoojaDetails = [...bookingData.poojaDetails];
//     updatedPoojaDetails[index] = { ...updatedPoojaDetails[index], [name]: value };
//     setBookingData({ ...bookingData, poojaDetails: updatedPoojaDetails });
//   };

//   const addPoojaDetail = () => {
//     setCount(count + 1);
//     setBookingData({
//       ...bookingData,
//       poojaDetails: [
//         ...bookingData.poojaDetails,
//         { poojaName: '', amount: '' }
//       ]
//     });
//   };

//   const removePoojaDetail = (index) => {
//     const updatedPoojaDetails = bookingData.poojaDetails.filter((_, i) => i !== index);
//     setBookingData({ ...bookingData, poojaDetails: updatedPoojaDetails });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     axios.post('https://posapi.emedha.in/api/create', bookingData)
//       .then(response => {
//         toast.success("Receipt generated successfully");
//         setBookingData({
//           mobileNumber: '',
//           customerName: '',
//           gothram: '',
//           poojaDate: '',
//           poojaDetails: [],
//         });
//       })
//       .catch(error => {
//         toast.error("Error generating receipt");
//         console.error("Error:", error);
//       });
//   };

//   return (
//     <>
//     <Sidebar />
//     <div id='main' >
//       <h1>Pooja Master - Add Bookings</h1>
//       <form onSubmit={handleSubmit}>
//         <div>
//           <label>Mobile Number:</label>
//           <input
//             type="text"
//             name="mobileNumber"
//             value={bookingData.mobileNumber}
//             onChange={handleInputChange}
//             required
//           />
//         </div>

//         <div>
//           <label>Customer Name:</label>
//           <input
//             type="text"
//             name="customerName"
//             value={bookingData.customerName}
//             onChange={handleInputChange}
//             required
//           />
//         </div>

//         <div>
//           <label>Gothram:</label>
//           <input
//             type="text"
//             name="gothram"
//             value={bookingData.gothram}
//             onChange={handleInputChange}
//             required
//           />
//         </div>

//         <div>
//           <label>Pooja Date:</label>
//           <input
//             type="date"
//             name="poojaDate"
//             value={bookingData.poojaDate}
//             onChange={handleInputChange}
//             required
//           />
//         </div>

//         <h3>Select Pooja</h3>
//         {bookingData.poojaDetails.map((pooja, index) => (
//           <div key={index} style={{ display: 'flex', marginBottom: '10px' }}>
//             <select
//               name="poojaName"
//               value={pooja.poojaName}
//               onChange={(e) => handlePoojaChange(index, e)}
//               required
//             >
//               <option value="">--Select Pooja--</option>
//               {poojaList.map(pooja => (
//                 <option key={pooja.pid} value={pooja.pname}>
//                   {pooja.pname}
//                 </option>
//               ))}
//             </select>
//             <input
//               type="text"
//               name="amount"
//               value={pooja.amount}
//               onChange={(e) => handlePoojaChange(index, e)}
//               placeholder="Enter Amount"
//               required
//             />
//             <button type="button" onClick={() => removePoojaDetail(index)}>Remove</button>
//           </div>
//         ))}
//         <button type="button" onClick={addPoojaDetail}>Add Pooja</button>
//         <button type="submit">Generate Receipt</button>
//       </form>
//       <ToastContainer />
//     </div>
//     </>
//   );
// }

// export default PoojaBooking;


// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import Swal from 'react-sweetalert2';
// import 'sweetalert2/dist/sweetalert2.min.css';
// // import './PoojaBooking.css';

// import Sidebar from '../Sidebar/Sidebar'

// export default function PoojaBooking() {
//   const [mobileNumber, setMobileNumber] = useState('');
//   const [customerName, setCustomerName] = useState('');
//   const [gothram, setGothram] = useState('');
//   const [poojadate, setPoojadate] = useState('');
//   const [poojaDetails, setPoojaDetails] = useState([{ poojaname: '', amount: '' }]);
//   const [poojaOptions, setPoojaOptions] = useState([]);

//   // Fetch pooja options on mount
//   useEffect(() => {
//     axios.get('http://localhost:5000/api/pooja')
//       .then(response => setPoojaOptions(response.data))
//       .catch(error => console.error(error));
//   }, []);

//   // Fetch customer details when mobile number is entered
//   const fetchCustomerDetails = (mobile) => {
//     if (mobile.length === 10) {
//       axios.get(`http://localhost:5000/api/customer?mobile=${mobile}`)
//         .then(response => {
//           const data = response.data;
//           setCustomerName(data.customerName || '');
//           setGothram(data.gothram || '');
//         })
//         .catch(error => console.error(error));
//     }
//   };

//   const handleMobileChange = (e) => {
//     setMobileNumber(e.target.value);
//     fetchCustomerDetails(e.target.value);
//   };

//   // Fetch amount when pooja is selected
//   const handlePoojaChange = (e, index) => {
//     const { name, value } = e.target;
//     const newPoojaDetails = [...poojaDetails];
//     newPoojaDetails[index][name] = value;
//     setPoojaDetails(newPoojaDetails);

//     if (name === 'poojaname') {
//       axios.get(`http://localhost:5000/api/pooja/amount?pid=${value}`)
//         .then(response => {
//           const amount = response.data.pprice || '';
//           newPoojaDetails[index].amount = amount;
//           setPoojaDetails(newPoojaDetails);
//         })
//         .catch(error => console.error(error));
//     }
//   };

//   const handleAddOrder = () => {
//     setPoojaDetails([...poojaDetails, { poojaname: '', amount: '' }]);
//   };

//   const handleRemoveOrder = (index) => {
//     const newPoojaDetails = poojaDetails.filter((_, i) => i !== index);
//     setPoojaDetails(newPoojaDetails);
//   };

//   const handleSubmit = () => {
//     const requestData = {
//       mobileNumber,
//       customerName,
//       gothram,
//       poojadate,
//       poojaDetails
//     };

//     axios.post('http://localhost:5000/api/pooja', requestData)
//       .then(response => {
//         if (response.data.success) {
//           Swal.fire({
//             title: 'Success',
//             text: 'Receipt generated',
//             icon: 'success',
//             confirmButtonText: 'Continue',
//           });
//         }
//       })
//       .catch(error => console.error(error));
//   };

//   return (
//     <>
//     <Sidebar />
//     <div id='main'>
//       <h1>Pooja Master</h1>

//       <div>
//         <label>Mobile Number</label>
//         <input 
//           type="text" 
//           value={mobileNumber} 
//           onChange={handleMobileChange} 
//           placeholder="Enter Mobile Number"
//         />
//       </div>

//       <div>
//         <label>Customer Name</label>
//         <input 
//           type="text" 
//           value={customerName} 
//           disabled 
//           placeholder="Customer Name"
//         />
//       </div>

//       <div>
//         <label>Gothram</label>
//         <input 
//           type="text" 
//           value={gothram} 
//           disabled 
//           placeholder="Gothram"
//         />
//       </div>

//       <div>
//         <label>Pooja Date</label>
//         <input 
//           type="date" 
//           value={poojadate} 
//           onChange={(e) => setPoojadate(e.target.value)} 
//         />
//       </div>

//       <div>
//         <h3>Add Bookings</h3>
//         {poojaDetails.map((item, index) => (
//           <div key={index}>
//             <select
//               name="poojaname"
//               value={item.poojaname}
//               onChange={(e) => handlePoojaChange(e, index)}
//             >
//               <option value="">--Select Pooja--</option>
//               {poojaOptions.map((pooja) => (
//                 <option key={pooja.pid} value={pooja.pname}>
//                   {pooja.pname}
//                 </option>
//               ))}
//             </select>
//             <input
//               type="text"
//               name="amount"
//               value={item.amount}
//               onChange={(e) => handlePoojaChange(e, index)}
//               placeholder="Amount"
//               disabled
//             />
//             <button className="remove-btn" onClick={() => handleRemoveOrder(index)}>Remove</button>
//           </div>
//         ))}
//         <button onClick={handleAddOrder}>Add Order</button>
//       </div>

//       <button onClick={handleSubmit}>Generate Receipt</button>
//     </div>
//     </>
//   );
// }



// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// import 'sweetalert2/dist/sweetalert2.min.css';
// import Sidebar from '../Sidebar/Sidebar'

// export default function PoojaBooking() {
//   const [mobileNumber, setMobileNumber] = useState('');
//   const [customerName, setCustomerName] = useState('');
//   const [gothram, setGothram] = useState('');
//   const [poojadate, setPoojadate] = useState('');
//   const [poojaDetails, setPoojaDetails] = useState([{ poojaname: '', amount: '', pid: '' }]);
//   const [poojaOptions, setPoojaOptions] = useState([]);
//   const [isExistingCustomer, setIsExistingCustomer] = useState(true); 

//   useEffect(() => {
//     axios.get('https://posapi.emedha.in/api/pooja/booking')
//       .then(response => setPoojaOptions(response.data))
//       .catch(error => console.error(error));
//   }, []);

//   const fetchCustomerDetails = (mobile) => {
//     if (mobile.length === 10) {
//       axios.get(`https://posapi.emedha.in/api/customer/booking?mobile=${mobile}`)
//         .then(response => {
//           const data = response.data;
//           if (data) {
//             setCustomerName(data.customerName || '');
//             setGothram(data.gothram || '');
//             setIsExistingCustomer(true);  
//           } else {
//             setIsExistingCustomer(false); 
//             setCustomerName('');
//             setGothram('');
//           }
//         })
//         .catch(error => console.error(error));
//     }
//   };

//   const handleMobileChange = (e) => {
//     setMobileNumber(e.target.value);
//     fetchCustomerDetails(e.target.value);
//   };

//   const handlePoojaChange = (e, index) => {
//     const { name, value } = e.target;
//     const newPoojaDetails = [...poojaDetails];
//     newPoojaDetails[index][name] = value;
//     setPoojaDetails(newPoojaDetails);

//     if (name === 'poojaname') {
//       const selectedPooja = poojaOptions.find(pooja => pooja.pname === value);

//       if (selectedPooja) {
//         newPoojaDetails[index].amount = selectedPooja.pprice; 
//         newPoojaDetails[index].pid = selectedPooja.pid;
//       } else {
//         newPoojaDetails[index].amount = '';
//         newPoojaDetails[index].pid = '';
//       }
//     }

//     setPoojaDetails(newPoojaDetails);
//   };

//   const handleAddOrder = () => {
//     setPoojaDetails([...poojaDetails, { poojaname: '', amount: '', pid: '' }]);
//   };

//   const handleRemoveOrder = (index) => {
//     const newPoojaDetails = poojaDetails.filter((_, i) => i !== index);
//     setPoojaDetails(newPoojaDetails);
//   };


//   const handleSubmit = () => {
//     poojaDetails.forEach((pooja) => {
//       const requestData = {
//         mobileNumber,
//         customerName,
//         gothram,
//         poojadate,
//         amount: pooja.amount, 
//         poojaname: pooja.poojaname,  
//       };

//       // Send the data to backend
//       axios.post('https://posapi.emedha.in/api/pooja/booking', requestData)
//         .then(response => {
//           if (response.data.success) {

//             alert('Success: Booking successfully added.');

//           setMobileNumber('');
//           setCustomerName('');
//           setGothram('');
//           setPoojadate('');
//           setPoojaDetails([{ poojaname: '', amount: '', pid: '' }]);  

//           }
//         })
//         .catch(error => {
//           console.error(error);

//           alert('Error: There was an error processing your request.');
//         });
//     });
//   };


//   return (
//     <>
//       <Sidebar />
//       <div id='main'>
//         <h1>Pooja Master</h1>

//         {/* Mobile Number Section */}
//         <div>
//           <label>Mobile Number</label>
//           <input
//             type="text"
//             value={mobileNumber}
//             onChange={handleMobileChange}
//             placeholder="Enter Mobile Number"
//           />
//         </div>

//         <div>
//           <label>Customer Name</label>
//           <input
//             type="text"
//             value={customerName}
//             onChange={(e) => setCustomerName(e.target.value)}
//             placeholder="Enter Customer Name"

//           />
//         </div>

//         <div>
//           <label>Gothram</label>
//           <input
//             type="text"
//             value={gothram}
//             onChange={(e) => setGothram(e.target.value)}
//             placeholder="Enter Gothram"

//           />
//         </div>
//         <div>
//           <label>Pooja Date</label>
//           <input
//             type="date"
//             value={poojadate}
//             onChange={(e) => setPoojadate(e.target.value)}
//           />
//         </div>
//         <div>
//           <h3>Add Bookings</h3>
//           {poojaDetails.map((item, index) => (
//             <div key={index}>
//               <select
//                 name="poojaname"
//                 value={item.poojaname}
//                 onChange={(e) => handlePoojaChange(e, index)}
//               >
//                 <option value="">--Select Pooja--</option>
//                 {poojaOptions.map((pooja) => (
//                   <option key={pooja.pid} value={pooja.pname}>
//                     {pooja.pname}
//                   </option>
//                 ))}
//               </select>
//               <input
//                 type="text"
//                 name="amount"
//                 value={item.amount}
//                 onChange={(e) => handlePoojaChange(e, index)}
//                 placeholder="Amount"
//                 disabled
//               />
//               <button className="remove-btn" onClick={() => handleRemoveOrder(index)}>Remove</button>
//             </div>
//           ))}
//           <button onClick={handleAddOrder}>Add Order</button>
//         </div>
//         <button onClick={handleSubmit}>Generate Receipt</button>
//       </div>
//     </>
//   );
// }



// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import Swal from 'sweetalert2';
// import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
// import Sidebar from '../Sidebar/Sidebar';
// import ReactSelect from 'react-select';



// export default function PoojaBooking() {
//   const [mobileNumber, setMobileNumber] = useState('');
//   const [customerName, setCustomerName] = useState('');
//   const [gothram, setGothram] = useState('');
//   const [poojadate, setPoojadate] = useState('');
//   const [poojaDetails, setPoojaDetails] = useState([{ poojaname: '', amount: '', pid: '' }]);
//   const [poojaOptions, setPoojaOptions] = useState([]);
//   const [isExistingCustomer, setIsExistingCustomer] = useState(true);

//   useEffect(() => {
//     axios.get('https://posapi.emedha.in/api/pooja/booking')
//       .then(response => setPoojaOptions(response.data))
//       .catch(error => console.error(error));
//   }, []);

//   const fetchCustomerDetails = (mobile) => {
//     if (mobile.length === 10) {
//       axios.get(`https://posapi.emedha.in/api/customer/booking?mobile=${mobile}`)
//         .then(response => {
//           const data = response.data;
//           if (data) {
//             setCustomerName(data.customerName || '');
//             setGothram(data.gothram || '');
//             setIsExistingCustomer(true);
//           } else {
//             setIsExistingCustomer(false);
//             setCustomerName('');
//             setGothram('');
//           }
//         })
//         .catch(error => console.error(error));
//     }
//   };

//   const handleMobileChange = (e) => {
//     setMobileNumber(e.target.value);
//     fetchCustomerDetails(e.target.value);
//   };

//   const handlePoojaChange = (e, index) => {
//     const { name, value } = e.target;
//     const newPoojaDetails = [...poojaDetails];
//     newPoojaDetails[index][name] = value;
//     setPoojaDetails(newPoojaDetails);

//     if (name === 'poojaname') {
//       const selectedPooja = poojaOptions.find(pooja => pooja.pname === value);

//       if (selectedPooja) {
//         newPoojaDetails[index].amount = selectedPooja.pprice;
//         newPoojaDetails[index].pid = selectedPooja.pid;
//       } else {
//         newPoojaDetails[index].amount = '';
//         newPoojaDetails[index].pid = '';
//       }
//     }

//     setPoojaDetails(newPoojaDetails);
//   };

//   const handleAddOrder = () => {
//     setPoojaDetails([...poojaDetails, { poojaname: '', amount: '', pid: '' }]);
//   };

//   const handleRemoveOrder = (index) => {
//     const newPoojaDetails = poojaDetails.filter((_, i) => i !== index);
//     setPoojaDetails(newPoojaDetails);
//   };

//   const handleSubmit = () => {
//     poojaDetails.forEach((pooja) => {
//       const requestData = {
//         mobileNumber,
//         customerName,
//         gothram,
//         poojadate,
//         amount: pooja.amount,
//         poojaname: pooja.poojaname,
//       };

//       axios.post('https://posapi.emedha.in/api/pooja/booking', requestData)
//         .then(response => {
//           if (response.data.success) {
//             Swal.fire({
//               icon: 'success',
//               title: 'Success',
//               text: 'Booking successfully added.',
//             }).then(() => {
//               setMobileNumber('');
//               setCustomerName('');
//               setGothram('');
//               setPoojadate('');
//               setPoojaDetails([{ poojaname: '', amount: '', pid: '' }]);
//             });
//           }
//         })
//         .catch(error => {
//           Swal.fire({
//             icon: 'error',
//             title: 'Error',
//             text: 'There was an error processing your request.',
//           });
//         });
//     });
//   };

//   return (
//     <>
//       <Sidebar />
//       <Container id="main" className="mt-4">
//         <h1 className="text-center mb-4">Pooja Ticket Booking</h1>

//         <Form>
//           {/* Mobile Number Section */}
//           <Form.Group as={Row} controlId="formMobile">
//             <Form.Label column sm={2}>Mobile Number</Form.Label>
//             <Col sm={8} md={6} lg={4}>
//               <Form.Control
//                 type="text"
//                 style={{padding:'5px'}}
//                 value={mobileNumber}
//                 onChange={handleMobileChange}
//                 placeholder="Enter Mobile Number"
//               />
//             </Col>
//           </Form.Group>

//           {/* Customer Name Section */}
//           <Form.Group as={Row} controlId="formCustomerName">
//             <Form.Label column sm={2}>Customer Name</Form.Label>
//             <Col sm={10} md={6} lg={4}>
//               <Form.Control
//                 type="text" style={{padding:'5px'}}
//                 value={customerName}
//                 onChange={(e) => setCustomerName(e.target.value)}
//                 placeholder="Enter Customer Name"
//               />
//             </Col>
//           </Form.Group>

//           {/* Gothram Section */}
//           <Form.Group as={Row} controlId="formGothram">
//             <Form.Label column sm={2}>Gothram</Form.Label>
//             <Col sm={10} md={6} lg={4}>
//               <Form.Control
//                 type="text" style={{padding:'5px'}}
//                 value={gothram}
//                 onChange={(e) => setGothram(e.target.value)}
//                 placeholder="Enter Gothram"
//               />
//             </Col>
//           </Form.Group>

//           {/* Pooja Date Section */}
//           <Form.Group as={Row} controlId="formPoojaDate">
//             <Form.Label column sm={2}>Pooja Date</Form.Label>
//             <Col sm={10} md={6} lg={4}>
//               <Form.Control
//                 type="date" style={{padding:'5px'}}
//                 value={poojadate}
//                 onChange={(e) => setPoojadate(e.target.value)}
//               />
//             </Col>
//           </Form.Group>

//           {/* Add Bookings Section */}
//           <h3>Add Bookings</h3>
//           {poojaDetails.map((item, index) => (
//             <Row key={index} className="mb-3">
//               <Col sm={10} md={6} lg={4}>
//                 {/* <Form.Control
//                   as="select"
//                   name="poojaname"
//                   value={item.poojaname}
//                   onChange={(e) => handlePoojaChange(e, index)}
//                 >
//                   <option value="">--Select Pooja--</option>
//                   {poojaOptions.map((pooja) => (
//                     <option key={pooja.pid} value={pooja.pname}>
//                       {pooja.pname}
//                     </option>
//                   ))}
//                 </Form.Control> */}
//                 <Form.Group as={Row} controlId="formPoojaname">
//                   <Form.Label column sm={4}>Pooja Name</Form.Label>
//                   <Col sm={8} md={6} lg={4}>
//                     <ReactSelect
//                       options={poojaOptions.map(pooja => ({
//                         value: pooja.pname,
//                         label: pooja.pname
//                       }))}
//                       value={{ value: item.poojaname, label: item.poojaname }}
//                       onChange={(selectedOption) => handlePoojaChange({
//                         target: { name: "poojaname", value: selectedOption.value }
//                       }, index)}
//                       isSearchable={true}
//                       styles={{
//                         menu: (base) => ({
//                         ...base,

//                        width:'215px',
//                        height:'auto'
//                       }),
//                       control: (base) => ({
//                         ...base,
//                         width: '200px',  // Adjusts the width of the input field (the bar where text is entered)
//                         fontSize: '14px',  // Optional: adjust the font size for the input field
//                       }),
//                     }}

//                     />
//                   </Col>
//                 </Form.Group>
//               </Col>
//               <Col sm={10} md={6} lg={4}>
//                 <Form.Control
//                   type="text"
//                   name="amount"
//                   value={item.amount}
//                   onChange={(e) => handlePoojaChange(e, index)}
//                   placeholder="Amount"
//                   disabled
//                 />
//               </Col>
//               <Col sm={3} className="d-flex justify-content-between">
//                 <Button variant="danger" onClick={() => handleRemoveOrder(index)}>
//                   Remove
//                 </Button>
//               </Col>
//             </Row>
//           ))}


//           <Button variant="primary" onClick={handleAddOrder}>Add Order</Button>
//           <br></br>
//           {/* Submit Button */}
//           <Button variant="success" className="mt-4 " onClick={handleSubmit}>Generate Receipt</Button>
//         </Form>
//       </Container>
//     </>
//   );
// }



// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import Swal from 'sweetalert2';
// import { Container, Row, Col, Form, Button, Modal } from 'react-bootstrap';
// import Sidebar from '../Sidebar/Sidebar';
// import ReactSelect from 'react-select';
// import './PoojaBooking.css';  // Ensure to import the CSS file

// export default function PoojaBooking() {
//   const [mobileNumber, setMobileNumber] = useState('');
//   const [customerName, setCustomerName] = useState('');
//   const [gothram, setGothram] = useState('');
//   const [poojadate, setPoojadate] = useState('');
//   const [poojaDetails, setPoojaDetails] = useState([{ poojaname: '', amount: '', pid: '' }]);
//   const [poojaOptions, setPoojaOptions] = useState([]);
//   const [ticketData, setTicketData] = useState(null);
//   const [isExistingCustomer, setIsExistingCustomer] = useState(true);
//   const [showTicketModal, setShowTicketModal] = useState(false);

//   useEffect(() => {
//     axios.get('https://posapi.emedha.in/api/pooja/booking')
//       .then(response => setPoojaOptions(response.data))
//       .catch(error => console.error(error));
//   }, []);

//   const fetchCustomerDetails = (mobile) => {
//     if (mobile.length === 10) {
//       axios.get(`https://posapi.emedha.in/api/customer/booking?mobile=${mobile}`)
//         .then(response => {
//           const data = response.data;
//           if (data) {
//             setCustomerName(data.customerName || '');
//             setGothram(data.gothram || '');
//             setIsExistingCustomer(true);
//           } else {
//             setIsExistingCustomer(false);
//             setCustomerName('');
//             setGothram('');
//           }
//         })
//         .catch(error => console.error(error));
//     }
//   };

//   const handleMobileChange = (e) => {
//     setMobileNumber(e.target.value);
//     fetchCustomerDetails(e.target.value);
//   };

//   const handlePoojaChange = (e, index) => {
//     const { name, value } = e.target;
//     const newPoojaDetails = [...poojaDetails];
//     newPoojaDetails[index][name] = value;
//     setPoojaDetails(newPoojaDetails);

//     if (name === 'poojaname') {
//       const selectedPooja = poojaOptions.find(pooja => pooja.pname === value);
//       if (selectedPooja) {
//         newPoojaDetails[index].amount = selectedPooja.pprice;
//         newPoojaDetails[index].pid = selectedPooja.pid;
//       } else {
//         newPoojaDetails[index].amount = '';
//         newPoojaDetails[index].pid = '';
//       }
//     }
//     setPoojaDetails(newPoojaDetails);
//   };

//   const handleAddOrder = () => {
//     setPoojaDetails([...poojaDetails, { poojaname: '', amount: '', pid: '' }]);
//   };

//   const handleRemoveOrder = (index) => {
//     const newPoojaDetails = poojaDetails.filter((_, i) => i !== index);
//     setPoojaDetails(newPoojaDetails);
//   };

//   const handleSubmit = () => {
//     poojaDetails.forEach((pooja) => {
//       const requestData = {
//         mobileNumber,
//         customerName,
//         gothram,
//         poojadate,
//         amount: pooja.amount,
//         poojaname: pooja.poojaname,
//       };

//       axios.post('https://posapi.emedha.in/api/pooja/booking', requestData)
//         .then(response => {
//           if (response.data.success) {
//             Swal.fire({
//               icon: 'success',
//               title: 'Success',
//               text: 'Booking successfully added.',
//             }).then(() => {
//               const generatedTicket = {
//                 customerName,
//                 mobileNumber,
//                 gothram,
//                 poojadate,
//                 poojaDetails: poojaDetails,
//               };
//               setTicketData(generatedTicket);
//               setShowTicketModal(true);
//               setMobileNumber('');
//               setCustomerName('');
//               setGothram('');
//               setPoojadate('');
//               setPoojaDetails([{ poojaname: '', amount: '', pid: '' }]);
//               setIsExistingCustomer(true);  // Reset if needed
//             });
//           }
//         })
//         .catch(error => {
//           Swal.fire({
//             icon: 'error',
//             title: 'Error',
//             text: 'There was an error processing your request.',
//           });
//         });
//     });
//   };

//   // const handlePrintTicket = () => {
//   //   const printWindow = window.open('', '', 'height=600,width=800');
//   //   printWindow.document.write('<html><head><title>Ticket</title></head><body>');
//   //   printWindow.document.write('<div class="ticket-container">');
//   //   printWindow.document.write('<h1 class="ticket-title">Pooja Booking Ticket</h1>');
//   //   printWindow.document.write(`<p><strong>Customer Name:</strong> ${ticketData.customerName}</p>`);
//   //   printWindow.document.write(`<p><strong>Mobile Number:</strong> ${ticketData.mobileNumber}</p>`);
//   //   printWindow.document.write(`<p><strong>Gothram:</strong> ${ticketData.gothram}</p>`);
//   //   printWindow.document.write(`<p><strong>Pooja Date:</strong> ${ticketData.poojadate}</p>`);
//   //   printWindow.document.write('<h3>Pooja Details</h3>');
//   //   ticketData.poojaDetails.forEach(pooja => {
//   //     printWindow.document.write(`<p><strong>Pooja Name:</strong> ${pooja.poojaname}</p>`);
//   //     printWindow.document.write(`<p><strong>Amount:</strong> ${pooja.amount}</p>`);
//   //   });
//   //   printWindow.document.write('</div>');
//   //   printWindow.document.write('</body></html>');
//   //   printWindow.document.close();
//   //   printWindow.print();
//   // };


//   const handlePrintTicket = () => {
//     const printWindow = window.open('', '', 'height=600,width=800');
//     printWindow.document.write('<html><head><title>Ticket</title>');

//     // Add styles for printing the ticket in the same format as in the modal
//     printWindow.document.write(`
//       <style>
//         body {

//           background-color: #f7f7f7;
//           margin: 0;
//           padding: 0;
//         }
//         .ticket-container {
//           background-color: #fff;
//           padding: 30px;
//           border-radius: 15px;
//           border: 2px solid #2c3e50;
//           box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);

//           width: 70%;
//           margin: 0 auto;
//         }
//         .ticket-title {
//           font-size: 32px;
//           font-weight: bold;
//           text-align: center;
//           color: #2c3e50;
//           margin-bottom: 20px;
//         }
//         .ticket-container p {
//           font-size: 18px;
//           line-height: 1.6;
//           color: #34495e;
//         }
//         .ticket-container h3 {
//           font-size: 24px;
//           margin-top: 20px;
//           color: #2c3e50;
//           border-top: 2px solid #2c3e50;
//           padding-top: 10px;
//         }
//         .ticket-container strong {
//           color: #2980b9;
//         }
//       </style>
//     `);

//     // Write the ticket content to the print window
//     printWindow.document.write('<body>');
//     printWindow.document.write('<div class="ticket-container">');
//     printWindow.document.write('<h1 class="ticket-title">Pooja Booking Ticket</h1>');

//     // Ticket details
//     printWindow.document.write(`<p><strong>Customer Name:</strong> ${ticketData.customerName}</p>`);
//     printWindow.document.write(`<p><strong>Mobile Number:</strong> ${ticketData.mobileNumber}</p>`);
//     printWindow.document.write(`<p><strong>Gothram:</strong> ${ticketData.gothram}</p>`);
//     printWindow.document.write(`<p><strong>Pooja Date:</strong> ${ticketData.poojadate}</p>`);

//     printWindow.document.write('<h3>Pooja Details</h3>');

//     ticketData.poojaDetails.forEach(pooja => {
//       printWindow.document.write(`<p><strong>Pooja Name:</strong> ${pooja.poojaname}</p>`);
//       printWindow.document.write(`<p><strong>Amount:</strong> ${pooja.amount}</p>`);
//     });

//     printWindow.document.write('</div>');
//     printWindow.document.write('</body></html>');

//     // Close the document and trigger the print dialog
//     printWindow.document.close();
//     printWindow.print();
// };

//   return (
//     <>
//       <Sidebar />
//       <Container id="main" className="mt-4">
//         <h1 className="text-center mb-4">Pooja Ticket Booking</h1>

//         <Form>
//           {/* Mobile Number Section */}
//           <Form.Group as={Row} controlId="formMobile">
//             <Form.Label column sm={2}>Mobile Number</Form.Label>
//             <Col sm={8} md={6} lg={4}>
//               <Form.Control
//                 type="text"
//                 style={{ padding: '5px' }}
//                 value={mobileNumber}
//                 onChange={handleMobileChange}
//                 placeholder="Enter Mobile Number"
//               />
//             </Col>
//           </Form.Group>

//           {/* Customer Name Section */}
//           <Form.Group as={Row} controlId="formCustomerName">
//             <Form.Label column sm={2}>Customer Name</Form.Label>
//             <Col sm={10} md={6} lg={4}>
//               <Form.Control
//                 type="text" style={{ padding: '5px' }}
//                 value={customerName}
//                 onChange={(e) => setCustomerName(e.target.value)}
//                 placeholder="Enter Customer Name"
//               />
//             </Col>
//           </Form.Group>

//           {/* Gothram Section */}
//           <Form.Group as={Row} controlId="formGothram">
//             <Form.Label column sm={2}>Gothram</Form.Label>
//             <Col sm={10} md={6} lg={4}>
//               <Form.Control
//                 type="text" style={{ padding: '5px' }}
//                 value={gothram}
//                 onChange={(e) => setGothram(e.target.value)}
//                 placeholder="Enter Gothram"
//               />
//             </Col>
//           </Form.Group>

//           {/* Pooja Date Section */}
//           <Form.Group as={Row} controlId="formPoojaDate">
//             <Form.Label column sm={2}>Pooja Date</Form.Label>
//             <Col sm={10} md={6} lg={4}>
//               <Form.Control
//                 type="date" style={{ padding: '5px' }}
//                 value={poojadate}
//                 onChange={(e) => setPoojadate(e.target.value)}
//               />
//             </Col>
//           </Form.Group>

//           {/* Add Bookings Section */}
//           <h3>Add Bookings</h3>
//           {poojaDetails.map((item, index) => (
//             <Row key={index} className="mb-3">
//               <Col sm={10} md={6} lg={4}>
//                 <Form.Group as={Row} controlId="formPoojaname">
//                   <Form.Label column sm={4}>Pooja Name</Form.Label>
//                   <Col sm={8} md={6} lg={4}>
//                     <ReactSelect
//                       options={poojaOptions.map(pooja => ({
//                         value: pooja.pname,
//                         label: pooja.pname
//                       }))}
//                       value={{ value: item.poojaname, label: item.poojaname }}
//                       onChange={(selectedOption) => handlePoojaChange({
//                         target: { name: "poojaname", value: selectedOption.value }
//                       }, index)}
//                       isSearchable={true}
//                       styles={{
//                         menu: (base) => ({
//                           ...base,
//                           width: '215px',
//                           height: 'auto'
//                         }),
//                         control: (base) => ({
//                           ...base,
//                           width: '200px',  // Adjusts the width of the input field
//                           fontSize: '14px',
//                         }),
//                       }}
//                     />
//                   </Col>
//                 </Form.Group>
//               </Col>
//               <Col sm={10} md={6} lg={4}>
//                 <Form.Control
//                   type="text"
//                   name="amount"
//                   value={item.amount}
//                   onChange={(e) => handlePoojaChange(e, index)}
//                   placeholder="Amount"
//                   disabled
//                 />
//               </Col>
//               <Col sm={3} className="d-flex justify-content-between">
//                 <Button variant="danger" onClick={() => handleRemoveOrder(index)}>
//                   Remove
//                 </Button>
//               </Col>
//             </Row>
//           ))}

//           <Button variant="primary" onClick={handleAddOrder}>Add Order</Button>
//           <br></br>
//           {/* Submit Button */}
//           <Button variant="success" className="mt-4 " onClick={handleSubmit}>Generate Receipt</Button>
//         </Form>
//       </Container>

//       {/* Ticket Modal */}
//       <Modal show={showTicketModal} onHide={() => setShowTicketModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Booking Ticket</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {ticketData && (
//             <div className="ticket-container">
//               <h1 className="ticket-title">Pooja Booking Ticket</h1>
//               <p><strong>Customer Name:</strong> {ticketData.customerName}</p>
//               <p><strong>Mobile Number:</strong> {ticketData.mobileNumber}</p>
//               <p><strong>Gothram:</strong> {ticketData.gothram}</p>
//               <p><strong>Pooja Date:</strong> {ticketData.poojadate}</p>
//               <h3>Pooja Details</h3>
//               {ticketData.poojaDetails.map((pooja, index) => (
//                 <div key={index}>
//                   <p><strong>Pooja Name:</strong> {pooja.poojaname}</p>
//                   <p><strong>Amount:</strong> {pooja.amount}</p>
//                 </div>
//               ))}
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowTicketModal(false)}>
//             Close
//           </Button>
//           <Button variant="primary" onClick={handlePrintTicket}>
//             Print Ticket
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// }


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import Sidebar from '../Sidebar/Sidebar';
import ReactSelect from 'react-select';

// Self-contained SVG Icons
const Icons = {
  Trash2: (size = 14) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="3 6 5 6 21 6"></polyline>
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
      <line x1="10" y1="11" x2="10" y2="17"></line>
      <line x1="14" y1="11" x2="14" y2="17"></line>
    </svg>
  ),
  Print: (size = 14) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="6 9 6 2 18 2 18 9"></polyline>
      <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
      <rect x="6" y="14" width="12" height="8"></rect>
    </svg>
  )
};

export default function PoojaBooking() {
  const [mobileNumber, setMobileNumber] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [gothram, setGothram] = useState('');
  const [poojadate, setPoojadate] = useState('');
  const [poojaDetails, setPoojaDetails] = useState([{ poojaname: '', amount: '', pid: '' }]);
  const [poojaOptions, setPoojaOptions] = useState([]);
  const [ticketData, setTicketData] = useState(null);
  const [isExistingCustomer, setIsExistingCustomer] = useState(true);
  const [showTicketModal, setShowTicketModal] = useState(false);

  // Responsive state
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    axios.get('https://posapi.emedha.in/api/pooja/booking')
      .then(response => setPoojaOptions(response.data || []))
      .catch(error => console.error(error));
  }, []);

  const fetchCustomerDetails = (mobile) => {
    if (mobile.length === 10) {
      axios.get(`https://posapi.emedha.in/api/customer/booking?mobile=${mobile}`)
        .then(response => {
          const data = response.data;
          if (data) {
            setCustomerName(data.customerName || '');
            setGothram(data.gothram || '');
            setIsExistingCustomer(true);
          } else {
            setIsExistingCustomer(false);
            setCustomerName('');
            setGothram('');
          }
        })
        .catch(error => console.error(error));
    }
  };

  const handleMobileChange = (e) => {
    setMobileNumber(e.target.value);
    fetchCustomerDetails(e.target.value);
  };

  const handlePoojaChange = (e, index) => {
    const { name, value } = e.target;
    const newPoojaDetails = [...poojaDetails];
    newPoojaDetails[index][name] = value;
    setPoojaDetails(newPoojaDetails);

    if (name === 'poojaname') {
      const selectedPooja = poojaOptions.find(pooja => pooja.pname === value);
      if (selectedPooja) {
        newPoojaDetails[index].amount = selectedPooja.pprice;
        newPoojaDetails[index].pid = selectedPooja.pid;
      } else {
        newPoojaDetails[index].amount = '';
        newPoojaDetails[index].pid = '';
      }
    }
    setPoojaDetails(newPoojaDetails);
  };

  const handleAddOrder = () => {
    setPoojaDetails([...poojaDetails, { poojaname: '', amount: '', pid: '' }]);
  };

  const handleRemoveOrder = (index) => {
    const newPoojaDetails = poojaDetails.filter((_, i) => i !== index);
    setPoojaDetails(newPoojaDetails);
  };

  const handleSubmit = () => {
    if (!mobileNumber.trim() || !customerName.trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Details',
        text: 'Please enter at least customer name and mobile number.'
      });
      return;
    }

    poojaDetails.forEach((pooja) => {
      const requestData = {
        mobileNumber,
        customerName,
        gothram,
        poojadate,
        amount: pooja.amount,
        poojaname: pooja.poojaname,
      };

      axios.post('https://posapi.emedha.in/api/pooja/booking', requestData)
        .then(response => {
          if (response.data.success) {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Booking successfully added.',
            }).then(() => {
              const generatedTicket = {
                customerName,
                mobileNumber,
                gothram,
                poojadate,
                poojaDetails: poojaDetails,
              };
              setTicketData(generatedTicket);
              setShowTicketModal(true);
              setMobileNumber('');
              setCustomerName('');
              setGothram('');
              setPoojadate('');
              setPoojaDetails([{ poojaname: '', amount: '', pid: '' }]);
              setIsExistingCustomer(true);
            });
          }
        })
        .catch(error => {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'There was an error processing your request.',
          });
        });
    });
  };

  const handlePrintTicket = () => {
    const printWindow = window.open('', '', 'height=600,width=800');
    printWindow.document.write('<html><head><title>Ticket</title>');
    printWindow.document.write(`
      <style>
        body {
          background-color: #f7f7f7;
          margin: 0;
          padding: 20px;
          font-family: system-ui, -apple-system, sans-serif;
        }
        .ticket-container {
          background-color: #fff;
          padding: 30px;
          border-radius: 15px;
          border: 2px solid #ffedd5;
          box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.05);
          width: 80%;
          margin: 0 auto;
        }
        .ticket-title {
          font-size: 28px;
          font-weight: bold;
          text-align: center;
          color: #c2410c;
          margin-bottom: 20px;
          font-family: 'Cinzel', serif;
        }
        .ticket-container p {
          font-size: 16px;
          line-height: 1.6;
          color: #374151;
          margin: 6px 0;
        }
        .ticket-container h3 {
          font-size: 20px;
          margin-top: 20px;
          color: #111827;
          border-top: 1px solid #ffedd5;
          padding-top: 10px;
        }
        .ticket-container strong {
          color: #c2410c;
        }
      </style>
    `);
    printWindow.document.write('<body>');
    printWindow.document.write('<div class="ticket-container">');
    printWindow.document.write('<h1 class="ticket-title">Pooja Booking Ticket</h1>');
    printWindow.document.write(`<p><strong>Customer Name:</strong> ${ticketData.customerName}</p>`);
    printWindow.document.write(`<p><strong>Mobile Number:</strong> ${ticketData.mobileNumber}</p>`);
    printWindow.document.write(`<p><strong>Gothram:</strong> ${ticketData.gothram}</p>`);
    printWindow.document.write(`<p><strong>Pooja Date:</strong> ${ticketData.poojadate}</p>`);
    printWindow.document.write('<h3>Pooja Details</h3>');
    ticketData.poojaDetails.forEach(pooja => {
      printWindow.document.write(`<p><strong>Pooja Name:</strong> ${pooja.poojaname}</p>`);
      printWindow.document.write(`<p><strong>Amount:</strong> ₹${pooja.amount}</p>`);
    });
    printWindow.document.write('</div>');
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <div
    //style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#fcfaf8' }}
    >
      <Sidebar />

      <div
      // id="main"
      // style={{
      //   flex: 1,
      //   display: 'flex',
      //   flexDirection: 'column',
      //   minWidth: 0,
      //   fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
      // }}
      >
        <div
          style={{
            padding: isMobile ? '16px' : '28px',
            maxWidth: '900px',
            width: '100%',
            margin: '0 auto',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px'
          }}
        >
          {/* Header */}
          <div>
            <h2
              style={{
                margin: 0,
                fontSize: isMobile ? '22px' : '26px',
                fontWeight: '700',
                color: '#111827',
                fontFamily: "'Cinzel', serif"
              }}
            >
              Pooja Ticket Booking
            </h2>
            <p style={{ margin: '4px 0 0 0', fontSize: '14px', color: '#6b7280' }}>
              Register devotees and schedule pooja offerings
            </p>
          </div>

          {/* Form Card */}
          <div
            style={{
              backgroundColor: '#ffffff',
              borderRadius: '16px',
              border: '1px solid #ffedd5',
              padding: isMobile ? '20px' : '28px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
              display: 'flex',
              flexDirection: 'column',
              gap: '18px',
              boxSizing: 'border-box'
            }}
          >
            {/* Top Grid Inputs */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
                gap: '16px'
              }}
            >
              {/* Mobile Number */}
              <div>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                  Mobile Number
                </label>
                <input
                  type="text"
                  placeholder="Enter Mobile Number"
                  value={mobileNumber}
                  onChange={handleMobileChange}
                  style={{
                    width: '100%',
                    padding: '11px 14px',
                    borderRadius: '12px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    outline: 'none',
                    backgroundColor: '#fdf8f3',
                    color: '#1f2937',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              {/* Customer Name */}
              <div>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                  Customer Name
                </label>
                <input
                  type="text"
                  placeholder="Enter Customer Name"
                  value={customerName}
                  onChange={(e) => setCustomerName(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '11px 14px',
                    borderRadius: '12px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    outline: 'none',
                    backgroundColor: '#fdf8f3',
                    color: '#1f2937',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              {/* Gothram */}
              <div>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                  Gothram
                </label>
                <input
                  type="text"
                  placeholder="Enter Gothram"
                  value={gothram}
                  onChange={(e) => setGothram(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '11px 14px',
                    borderRadius: '12px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    outline: 'none',
                    backgroundColor: '#fdf8f3',
                    color: '#1f2937',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              {/* Pooja Date */}
              <div>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                  Pooja Date
                </label>
                <input
                  type="date"
                  value={poojadate}
                  onChange={(e) => setPoojadate(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '11px 14px',
                    borderRadius: '12px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    outline: 'none',
                    backgroundColor: '#fdf8f3',
                    color: '#1f2937',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
            </div>

            {/* Dynamic Pooja Items Section */}
            <div style={{ marginTop: '8px' }}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '12px',
                  borderBottom: '1px solid #ffedd5',
                  paddingBottom: '8px'
                }}
              >
                <h3
                  style={{
                    margin: 0,
                    fontSize: '16px',
                    fontWeight: '700',
                    color: '#111827'
                  }}
                >
                  Pooja Offerings ({poojaDetails.length})
                </h3>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {poojaDetails.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      display: 'flex',
                      flexDirection: isMobile ? 'column' : 'row',
                      gap: '12px',
                      alignItems: isMobile ? 'stretch' : 'center',
                      backgroundColor: '#fff7ed',
                      padding: '12px',
                      borderRadius: '12px',
                      border: '1px solid #fed7aa'
                    }}
                  >
                    {/* Pooja Dropdown Selector */}
                    <div style={{ flex: 2 }}>
                      <ReactSelect
                        options={poojaOptions.map(pooja => ({
                          value: pooja.pname,
                          label: `${pooja.pname} (₹${pooja.pprice})`
                        }))}
                        value={item.poojaname ? { value: item.poojaname, label: item.poojaname } : null}
                        placeholder="Select Pooja Offering..."
                        onChange={(selectedOption) => handlePoojaChange({
                          target: { name: "poojaname", value: selectedOption ? selectedOption.value : '' }
                        }, index)}
                        isSearchable={true}
                        styles={{
                          control: (base) => ({
                            ...base,
                            backgroundColor: '#fdf8f3',
                            borderColor: '#e5e7eb',
                            borderRadius: '10px',
                            padding: '2px',
                            boxShadow: 'none',
                            fontSize: '14px',
                            '&:hover': {
                              borderColor: '#f97316'
                            }
                          }),
                          menu: (base) => ({
                            ...base,
                            borderRadius: '10px',
                            zIndex: 99
                          })
                        }}
                      />
                    </div>

                    {/* Amount Field */}
                    <div style={{ flex: 1 }}>
                      <input
                        type="text"
                        name="amount"
                        value={item.amount ? `₹${item.amount}` : ''}
                        placeholder="Amount"
                        disabled
                        style={{
                          width: '100%',
                          padding: '10px 14px',
                          borderRadius: '10px',
                          border: '1px solid #e5e7eb',
                          fontSize: '14px',
                          fontWeight: '700',
                          backgroundColor: '#ffffff',
                          color: '#ea580c',
                          boxSizing: 'border-box'
                        }}
                      />
                    </div>

                    {/* Remove Action Button */}
                    {poojaDetails.length > 1 && (
                      <button
                        type="button"
                        onClick={() => handleRemoveOrder(index)}
                        title="Remove Offering"
                        style={{
                          width: isMobile ? '100%' : '38px',
                          height: '38px',
                          borderRadius: '10px',
                          backgroundColor: '#fef2f2',
                          color: '#ef4444',
                          border: 'none',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '6px'
                        }}
                      >
                        {Icons.Trash2(14)}
                        {isMobile && <span style={{ fontSize: '12px', fontWeight: '600' }}>Remove</span>}
                      </button>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Form Actions */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
                gap: '12px',
                paddingTop: '8px'
              }}
            >
              <button
                type="button"
                onClick={handleAddOrder}
                style={{
                  padding: '12px 16px',
                  borderRadius: '12px',
                  color: '#c2410c',
                  backgroundColor: '#fff7ed',
                  border: '1px solid #fed7aa',
                  fontWeight: '600',
                  fontSize: '13px',
                  cursor: 'pointer',
                  boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                }}
              >
                + Add Another Offering
              </button>

              <button
                type="button"
                onClick={handleSubmit}
                style={{
                  padding: '12px 16px',
                  borderRadius: '12px',
                  color: '#ffffff',
                  fontWeight: '600',
                  fontSize: '13px',
                  border: 'none',
                  cursor: 'pointer',
                  background: 'linear-gradient(135deg, #f97316, #c2410c)',
                  boxShadow: '0 4px 16px rgba(249,115,22,0.3)'
                }}
              >
                Generate Receipt
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Ticket Modal */}
      {showTicketModal && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '16px',
            backgroundColor: 'rgba(0,0,0,0.45)',
            backdropFilter: 'blur(2px)'
          }}
          onClick={() => setShowTicketModal(false)}
        >
          <div
            style={{
              backgroundColor: '#ffffff',
              borderRadius: '16px',
              padding: '24px',
              width: '100%',
              maxWidth: '520px',
              boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
              boxSizing: 'border-box'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {ticketData && (
              <>
                <h3
                  style={{
                    margin: '0 0 12px 0',
                    fontSize: '20px',
                    fontWeight: '700',
                    color: '#111827',
                    fontFamily: "'Cinzel', serif",
                    textAlign: 'center'
                  }}
                >
                  Pooja Booking Ticket
                </h3>

                <div
                  style={{
                    backgroundColor: '#fff7ed',
                    borderRadius: '12px',
                    padding: '16px',
                    fontSize: '14px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                    marginBottom: '16px'
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{ color: '#6b7280' }}>Customer Name</span>
                    <span style={{ fontWeight: '600', color: '#111827' }}>{ticketData.customerName}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{ color: '#6b7280' }}>Mobile Number</span>
                    <span style={{ fontWeight: '600', color: '#111827' }}>{ticketData.mobileNumber}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{ color: '#6b7280' }}>Gothram</span>
                    <span style={{ fontWeight: '600', color: '#111827' }}>{ticketData.gothram}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{ color: '#6b7280' }}>Pooja Date</span>
                    <span style={{ fontWeight: '600', color: '#111827' }}>{ticketData.poojadate}</span>
                  </div>

                  <div style={{ borderTop: '1px solid #fed7aa', marginTop: '6px', paddingTop: '8px' }}>
                    <span style={{ fontSize: '13px', fontWeight: '700', color: '#c2410c' }}>Selected Poojas</span>
                    {ticketData.poojaDetails.map((pooja, index) => (
                      <div key={index} style={{ display: 'flex', justifyContent: 'space-between', marginTop: '4px' }}>
                        <span style={{ color: '#4b5563' }}>{pooja.poojaname}</span>
                        <span style={{ fontWeight: '700', color: '#ea580c' }}>₹{pooja.amount}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div style={{ display: 'flex', gap: '12px' }}>
                  <button
                    type="button"
                    onClick={() => setShowTicketModal(false)}
                    style={{
                      flex: 1,
                      padding: '10px 16px',
                      borderRadius: '10px',
                      border: '1px solid #e5e7eb',
                      fontSize: '14px',
                      fontWeight: '500',
                      color: '#4b5563',
                      backgroundColor: '#ffffff',
                      cursor: 'pointer'
                    }}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    onClick={handlePrintTicket}
                    style={{
                      flex: 1,
                      padding: '10px 16px',
                      borderRadius: '10px',
                      border: 'none',
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#ffffff',
                      background: 'linear-gradient(135deg, #f97316, #c2410c)',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px'
                    }}
                  >
                    {Icons.Print(15)}
                    <span>Print Ticket</span>
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}